import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-company-instructions',
  templateUrl: './create-company-instructions.component.html',
  standalone: false
})
export class CreateCompanyInstructionsComponent {

  private translate = inject(TranslateService);

  openContactMail(){
    window.open("mailto:pomoc@ekowitryna.pl?subject=Wsparcie%20z%20integracj%C4%85%20podmiotu%20w%20BDO%20mobile", "_blank");
  }

  openTutorialVideo(){
    window.open("https://youtu.be/i1zZkm7tOWg", "_blank", "noopener");
  }

  openWikiPage(){
    window.open('https://ekowitryna.pl/pomoc/bdomobile/utworzenie-podmiotu/', '_blank', 'noopener');
  }

  openPluginInstruction(){
    window.open('https://chromewebstore.google.com/detail/ekowitryna-integracja-z-b/lpolmjdnpipbpbgdfbgnoobloacclhfb?hl=pl&utm_source=ext_sidebar', '_blank', 'noopener');
  }
}
